import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { divisionEntity } from "../division/division-entity";
import { PlantsEntity } from "../plants/plants.entity";

@Entity('locations')

export class LocationsEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column('varchar', {
        name: 'location_name',
        nullable: true
    })
    locationName: string;

    @Column('varchar', {
        name: 'address',
        nullable: true
    })
    address: string;

    @Column('varchar', {
        name: 'unit_no',
        nullable: true
    })
    unitNo: string;

    // @Column('int', {
    //     name: 'division_id',
    //     nullable: true
    // })
    // divisionId: number;

    @Column('varchar', {
        name: 'state',
        nullable: true
    })
    state: string;

    @Column('varchar', {
        name: 'gps',
        nullable: true
    })
    gps: string;

    @Column('int', {
        name: 'plant_id',
        nullable: true
    })
    plantId: number;


    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;


    @ManyToOne(() => divisionEntity, dpom => dpom.dpomChild)
    @JoinColumn({ name: 'division_id' })
    dpom: divisionEntity;
    @ManyToOne(() => PlantsEntity, plant => plant.locationsInfo)
    @JoinColumn({ name: 'plant_id' })
    plantsInfo: PlantsEntity;
}